<div class="export-csv" *ngLet="vm$ | async as vm">
    <a
        mat-raised-button
        [attr.download]="vm.filename"
        [disabled]="vm.isButtonDisabled"
        [attr.href]="vm.hrefUrl"
        [attr.aria-label]="vm.ariaLabel"
    >
        <ng-content></ng-content>
    </a>
</div>
